import { getMakeAPI, Method } from '@golden/getch';
export function createSocketService(prefix, api, socket, version = 'v1') {
    let handleError = null;
    let handleReconnectError = null;
    const makeAPI = getMakeAPI(`${prefix}${version}`);
    const GET_ROOM_TOKEN = makeAPI(Method.GET, 'broadcasting/auth')();
    const join = (roomName, token) => {
        socket.emit('join', { room_name: roomName, ...token ? { token } : {} });
    };
    const leave = (roomName) => {
        socket.emit('leave', { room_name: roomName });
    };
    const sendSentryWhenFiveFailed = (attempt) => {
        if (attempt <= 5)
            return;
        socket.io.off('reconnect_attempt', sendSentryWhenFiveFailed);
        socket.io.once('reconnect_error', (error) => {
            handleReconnectError?.(error);
        });
    };
    socket.io.on('reconnect_attempt', sendSentryWhenFiveFailed);
    socket.on('connect', () => {
        join('global');
    });
    return {
        get handleError() {
            return handleError;
        },
        set handleError(fn) {
            handleError = fn;
        },
        get handleReconnectError() {
            return handleReconnectError;
        },
        set handleReconnectError(fn) {
            handleReconnectError = fn;
        },
        get instance() {
            return socket;
        },
        get isConnected() {
            return socket.connected;
        },
        connect() {
            socket.connect();
        },
        disconnect() {
            socket.disconnect();
        },
        getToken(room) {
            return api.fetch(GET_ROOM_TOKEN, { data: { room } });
        },
        join,
        leave
    };
}
//# sourceMappingURL=SocketService.js.map